<template>
    <div>
        <div class="c-case-part is-bg-king">
            <LayoutContent>
                <div class="c-case-inner-box">
                    <div class="inner-box is-side">
                        <span class="cd-case-img">
                            <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/case/case-img-01.png" />
                        </span>
                    </div>
                    <div class="inner-box is-content">
                        <h5 class="cd-title">
                            <span class="case-space is-logo">
                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-01.png" width="46px" height="46px" />
                            </span>
                            <span class="case-space is-text">{{ $t("main:王者荣耀") }}</span>
                        </h5>
                        <p class="cd-text-detail">{{ $t("main:《王者荣耀》是GVoice用户量最大的APP，使用了小队语音、语音消息、语音转文字、文明语音等功能。") }}</p>
                    </div>
                </div>
            </LayoutContent>
        </div>
        <div class="c-case-part is-odd is-bg-pubg">
            <LayoutContent>
                <div class="c-case-inner-box">
                    <div class="inner-box is-side">
                        <span class="cd-case-img">
                            <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/case/case-img-02.png" />
                        </span>
                    </div>
                    <div class="inner-box is-content">
                        <h5 class="cd-title">
                            <span class="case-space is-logo">
                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-02.png" width="46px" height="46px" />
                            </span>
                            <span class="case-space is-text">{{ $t("main:和平精英") }}</span>
                        </h5>
                        <p class="cd-text-detail">{{ $t("main:《和平精英》中玩家交流频率非常高，使用了小队语音、范围语音、语音消息、文明语音等功能。") }}</p>
                    </div>
                </div>
            </LayoutContent>
        </div>
        <div class="c-case-part is-bg-lol">
            <LayoutContent>
                <div class="c-case-inner-box">
                    <div class="inner-box is-side">
                        <span class="cd-case-img">
                            <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/case/case-img-03.png" />
                        </span>
                    </div>
                    <div class="inner-box is-content">
                        <h5 class="cd-title">
                            <span class="case-space is-logo">
                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/case/case-logo-03.png" width="143" height="44px" />
                            </span>
                            <span class="case-space is-text">{{ $t("main:英雄联盟") }}</span>
                        </h5>
                        <p class="cd-text-detail">{{ $t("main:《英雄联盟》是GVoice在PC端用户活跃最高的游戏 。主要针对好友开放了小队语音，且相关数据和稳定性远远高于国际版。") }}</p>
                    </div>
                </div>
            </LayoutContent>
        </div>
    </div>
</template>

<script>
import LayoutContent from "@/components/UI/LayoutContent.vue";
export default {
    name: "CasePart",
    components: { LayoutContent },
};
</script>

<style scoped lang="less">
.c-case-part {
    padding-left: 24px;
    padding-right: 24px;
    background-color: #151829;
    &:nth-child(1) {
        border-top: 4px solid #1f2138;
    }
    &:last-child {
        border-bottom: 4px solid #1f2138;
    }
    & + .c-case-part {
        border-top: 4px solid #456bfb;
    }
    &.is-odd {
        background-color: #fafdff;
        .c-case-inner-box {
            flex-direction: row-reverse;
        }
        .cd-title {
            .case-space {
                &.is-text {
                    color: #222222;
                }
            }
        }
    }
    &.is-bg-king {
        background: #151829 url(https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/case/case-bg-01.png) no-repeat center center;
        background-size: 1920px;
    }
    &.is-bg-pubg {
        background: #fff url(https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/case/case-bg-02.png) no-repeat center center;
        background-size: 1920px;
    }
    &.is-bg-lol {
        background: #151829 url(https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/case/case-bg-03.png) no-repeat center center;
        background-size: 1920px;
    }
}
.c-case-inner-box {
    display: flex;
    align-items: center;
    min-height: 570px;
    padding-top: 64px;
    padding-bottom: 64px;
    margin-left: -32px;
    margin-right: -32px;
    .inner-box {
        padding-left: 32px;
        padding-right: 32px;
        &.is-content {
            flex: 1;
            margin-top: -56px;
        }
    }
}
.cd-case-img {
    display: inline-flex;
    img {
        width: 640px;
    }
}
.cd-title {
    display: inline-flex;
    align-items: center;
    font-weight: normal;
    & + .cd-text-detail {
        margin-top: 32px;
    }
    .case-space {
        & + .case-space {
            margin-left: 16px;
        }
        &.is-text {
            font-size: 42px;
            line-height: 1;
            color: #fff;
        }
        &.is-logo {
            display: inline-flex;
        }
    }
}
.cd-text-detail {
    font-size: 18px;
    color: #8e919a;
    line-height: 2;
}
@media only screen and (max-width: 1200px) {
    .cd-case-img {
        display: flex;
        width: 100%;
        img {
            width: 100%;
            max-width: 640px;
        }
    }
    .cd-title {
        & + .cd-text-detail {
            margin-top: 16px;
        }
        .case-space {
            &.is-text {
                font-size: 32px;
            }
        }
    }
    .cd-text-detail {
        font-size: 16px;
        line-height: 1.8;
    }
    .c-case-inner-box {
        min-height: auto;
        margin-left: -24px;
        margin-right: -24px;
        .inner-box {
            flex: 1;
            padding-left: 24px;
            padding-right: 24px;
        }
    }
}
@media only screen and (max-width: 768px) {
    .c-case-part {
        &.is-odd {
            .c-case-inner-box {
                flex-direction: column;
            }
        }
        &.is-bg-king,
        &.is-bg-pubg,
        &.is-bg-lol {
            background-size: cover;
        }
    }
    .c-case-inner-box {
        flex-direction: column;
        .inner-box {
            &.is-content {
                margin-top: 40px;
            }
        }
    }
    .cd-title {
        .case-space {
            &.is-text {
                font-size: 24px;
            }
            &.is-logo {
                img {
                    width: auto;
                    height: 32px;
                }
            }
        }
    }
}
@media only screen and (max-width: 480px) {
}
</style>
